import request from '@/utils/request'
export const Download = '/icps/system/sign/settlement/pumpState/exportList'
/** 1.分页获取已结算列表和查看结算*/
export const queryPage2 = '/icps/system/sign/settlement/pumpDetail/queryPage'
/*2.分页获取未  结算列表**/
export const queryPage1 = '/icps/system/sign/settlement/pumpDetail/querySettlement'
/**3.分页获取结算单列表*/
export const queryPage3 = '/icps/system/sign/settlement/statement/get_statement_page'
/**4.获取结算单详情*/
export function queryMany(data) {
  return request({
    url: '/icps/system/sign/settlement/pumpState/queryMany',
    method: 'post',
    data
  })
}
/**5.生成结算详情*/
export function generateStatement(data) {
  return request({
    url: '/icps/system/sign/settlement/pumpDetail/generateStatement',
    method: 'post',
    data
  })
}
/**6.保存/提交审核*/
export function saveOrUpdate(data) {
  return request({
    url: '/icps/system/sign/settlement/pumpDetail/saveOrUpdate',
    method: 'post',
    data
  })
}
/**7.获取泵送列表*/
export function getContractVoList(data) {
  return request({
    url: '/icps/system/sign/dataCollection/contract/getContractVoList',
    method: 'get',
    params: data

  })
}
/**8.更改状态*/
export function update_status(data) {
  return request({
    url: '/icps/system/sign/settlement/statement/update_status ',
    method: 'post',
    data
  })
}









